var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Coomonly used API fetcher.
 * @param url - Endpoint URL
 * @param params - Request parameters
 * @returns Response from the server
 */
export const fetcher = (url, params) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch(process.env.API_URL + url, Object.assign(Object.assign({}, params), { headers: {
                'Content-Type': 'application/json',
                'multifarm-api-token': process.env.API_TOKEN
            } }));
        const json = yield response.json();
        if ((json === null || json === void 0 ? void 0 : json.error) === 'Not Authorized!') {
            throw new Error(json === null || json === void 0 ? void 0 : json.error);
        }
        return json;
    }
    catch (e) {
        throw e;
    }
});
